import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  description:
    "Subjective evaluation methods - MUSHRA in particular - are commonly employed in the development of lossy codecs. Enabling new codec operating point (for example, a lower bit rate) usually starts with listening experimentation to determine initial configuration of coding tools (represented by particular conditions in this case) that shows the greatest potential to improve audio quality. Such basis is further tuned to maximize coding performance. Use headphones to listen to provided samples and evaluate them using the MUSHRA scale.",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Participant view" }, { name: "Revealed description" }],
        },
      ],
      extraContent: [],
      components: [
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [6, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "iframe",
                          options: {
                            src: `${config.IFRAMES_STATIC_URL}/0226/index_nonames.html`,
                          },
                        },
                      },
                    },
                  ],
                  //second row
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "hint",
                          options: {
                            data:
                              "Additional information: the six different conditions include three lossy-coded samples (using the same bit rate), a hidden reference sample, and low-pass filter (3.5 kHz and 7 kHz) samples (“anchors”). During the experiment, this information is not presented to the participant.",
                            direction: "row",
                          },
                        },
                        styles: {
                          width: "80%",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [6, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "iframe",
                          options: {
                            src: `${config.IFRAMES_STATIC_URL}/0226/index.html`,
                          },
                        },
                      },
                    },
                  ],
                  //second row
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "hint",
                          options: {
                            data:
                              "Additional information: above you can see the revealed assignment of tested systems. What is your preference? Expert listeners chose System C as the best in this case. However, it is important to remember that a wide range of critical content genres (various music styles, live sports, commentary, etc.) is used in a real experiment.",
                            direction: "row",
                          },
                        },
                        styles: {
                          width: "80%",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
